import Vue from 'vue';
import store from '../store';
import moment from 'moment-timezone';
const tz = 'Europe/Tallinn';

let formatDate = Vue.filter('formatDate', function(date) {
    if (date !== null) {
        return moment(date).tz(tz).format('L');
    }
    return null;
});

let formatDateTime = Vue.filter('formatDateTime', function(date) {
    if (date !== null) {
        return moment(date).tz(tz).format('L LT');
    }
    return null;
});

let formatTime = Vue.filter('formatTime', function(date) {
    if (date !== null) {
        return moment(date).tz(tz).format('LT');
    }
    return null;
});


let valueOrDash = Vue.filter('valueOrDash', function(value) {
    if (value !== null) {
        return value;
    }
    return '-';
});

let valueOrDots = Vue.filter('valueOrDots', function(value) {
    if (value !== null) {
        return value;
    }
    return '...';
});

let truncate = Vue.filter('truncate', function(value, length) {
    length = length || 15;
    if (!value || typeof value !== 'string') {
        return '';
    }
    if (value.length <= length) {
        return value;
    }
    return value.substring(0, length) + '...';
});

let round = Vue.filter('round', function(value, decimals) {
    if (value > 0 && value !== null) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }
    return 0;
});

let striphtml = Vue.filter('striphtml', value => {
    let div = document.createElement('div');
    div.innerHTML = value;
    let text = div.textContent || div.innerText || '';
    return text;
});

let capitalize = Vue.filter('capitalize', value => {
    if (typeof value !== 'string') {
        return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
});

let toLower = Vue.filter('toLower', value => {
    return value.toLowerCase().trim();
});

let toUpper = Vue.filter('toUpper', value => {
    return value.toUpperCase().trim();
});

export const filters = {
    formatDate,
    formatDateTime,
    valueOrDash,
    formatTime,
    truncate,
    striphtml,
    round,
    capitalize,
    toLower,
    toUpper
};
